import type { Order } from "@/lib/api";

const CANCELLED_STATUSES = new Set(["cancelled", "canceled", "cancelado"]);

/**
 * O cancelamento (`POST /orders/{id}/cancel`) preenche `cancelledAt` e muda `status` para "cancelled",
 * mas não altera `portalB2BOrderStatus`. Ver .claude/docs/frontend_order_cancellation.md, seção 2.
 */
export function isOrderCancelled(
  order: Pick<Order, "cancelledAt" | "status" | "portalB2BOrderStatus">,
): boolean {
  return (
    !!order.cancelledAt ||
    CANCELLED_STATUSES.has(order.status?.toLowerCase()) ||
    CANCELLED_STATUSES.has(order.portalB2BOrderStatus?.toLowerCase())
  );
}

/**
 * Status de negócio no vocabulário que as telas exibem, a partir de um status solto.
 *
 * Pedido sem histórico de status guarda o status bruto ("pending" ou vazio), que é um pedido
 * recém-criado. Cru ele cai no mapa do `StateBadge` como "Aguardando confirmação", que é outro
 * estado — daí a tradução para "Criado". Mesma regra do `CASE order_status` de
 * `vw_order_items_report`, para quando a view ainda não traz o valor já traduzido.
 */
export function resolveDisplayOrderStatus(status: string | null | undefined): string {
  const raw = status?.trim().toLowerCase() ?? "";
  if (CANCELLED_STATUSES.has(raw)) return "Cancelado";
  if (raw === "" || raw === "pending" || raw === "created") return "Criado";
  return status!.trim();
}

/** Status usado nos filtros e métricas das listagens de pedidos. */
export function getOrderListStatus(order: Order): string {
  if (isOrderCancelled(order)) return "Cancelado";
  return resolveDisplayOrderStatus(order.portalB2BOrderStatus);
}
